export default __webpack_public_path__ + "static/media/tickCompletedAreYouCelebrity.b88d389f.gif";